import { DocumentLibraryPanel } from '@/components/settings/library/DocumentLibraryPanel'
import { AttachmentRulesPanel } from '@/components/settings/library/AttachmentRulesPanel'

// 2.11.19 + 2.11.20 — Reusable documents and picker visibility rules.
export function ReusableDocumentsPanel() {
  return (
    <div className='flex flex-col gap-4 bg-[#f4f5f8]'>
      <DocumentLibraryPanel embedded />
      <AttachmentRulesPanel embedded />
    </div>
  )
}

export default ReusableDocumentsPanel
